import { Action, ActionType } from 'typesafe-actions';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { ofType } from 'redux-observable';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { GetIdpCountryResponse, Actions, actions } from '@redux/modules/idpCountries';
import { TypedEpic } from './types';

export const getIdpCountriesEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_IDP_COUNTRIES),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getIdpCountries.request>[]
    >,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<GetIdpCountryResponse[]>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].ifkcountries,
        }),
      ).pipe(
        map((response) => actions.getIdpCountries.success(response.data)),
        catchError((err) =>
          of(
            actions.getIdpCountries.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente landlisten! Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [getIdpCountriesEpic];
